import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface Props {
  heading: string;
  paragraphs: string[]; // HTML-allowed (e.g. <strong>)
  keywords?: string[];
  ctaHref?: string;
  ctaLabel?: string;
}

const SEOContentBlock = ({ heading, paragraphs, keywords, ctaHref, ctaLabel }: Props) => {
  return (
    <section className="py-16 bg-muted/30 border-t border-border/40">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-brown mb-8 text-center">
          {heading}
        </h2>
        <div className="space-y-4 text-foreground/90 leading-relaxed text-base md:text-lg">
          {paragraphs.map((p, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
          ))}
        </div>

        {keywords && keywords.length > 0 && (
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {keywords.map((kw) => (
              <span
                key={kw}
                className="inline-block px-3 py-1 rounded-full bg-river/10 text-river text-xs md:text-sm font-cta font-medium border border-river/20"
              >
                {kw}
              </span>
            ))}
          </div>
        )}

        {ctaHref && ctaLabel && (
          <div className="mt-10 text-center">
            <Button variant="cta" size="lg" asChild>
              <Link to={ctaHref}>{ctaLabel}</Link>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default SEOContentBlock;
